/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const BoxColor = ({pickerHidden, setPickerHidden, bgColor}) => (
  <div
    css={styles}
    onClick={() => setPickerHidden(pickerHidden)}
    style={{ background: bgColor }}
    className="boxColor"
  ></div>
);

const styles = css`
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

export default BoxColor;
